var map = {
	"./organization-1-old-1.jpg": "a78d",
	"./organization-1-old.jpg": "9af1",
	"./organization-1.jpg": "0c6c",
	"./organization-2.jpg": "9365",
	"./organization-3.jpg": "23eb",
	"./organization-4.jpg": "37a8",
	"./organization-5.jpg": "c526",
	"./organization-x.jpg": "cd57"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2646";